import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function ICSECriteria() { 
  useEffect(() => {
    document.title = ' Criteria -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> ISCE  </li>
                <li>  Criteria</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Criteria</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                  <h5>Admissions to any other standard – (II- IX): </h5> 
                   <p>For vacancies available for classes II to IX, if notified through our website, then for such cases applications are accepted from 7th April every year till further notice. Applications are to be addressed to the Principal only. Kindly mention the class you are interested in and your contact numbers with email address very clearly. A copy each of the birth certificate and the latest progress report of the child is to be attached with the application.</p>
                
                   <ul className="mainlist">
                       <li>Incomplete applications will be disqualified. </li>
                       <li>The Last date for submitting the application will be displayed on website mercymemorialschool.com. </li>
                       <li>Late applications will not be entertained. </li>
                       <li>Please mention your email address and contact numbers clearly. In case a vacancy occurs, the school office will contact you. </li>     
                   </ul>
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ICSECriteria;
